import React, { useEffect, useMemo } from 'react';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { RouteType } from '@Pages/RetroSynthesis/constants';
import ConditionsTopPanel from './ConditionsTopPanel';
import StepDataConditions from './StepDataConditions';
import StepDataExamples from './StepDataExamples';

import './Conditions.custom.scss';

export const renderStepData = ({
  placement,
  type,
  onFullTextLinkClick,
  onIssueCitedCounterClick,
  onExperimentalProcedureOpen,
  onAbstractOpen,
  onAuthorClick,
  saveStepSelectionsHandler,
  loadLastExamples,
  ...stepData
}) => {
  switch (type) {
    case RouteType.PUBLISHED: {
      const { isLoading, data, step, selected } = stepData;
      return (
        <StepDataConditions
          isLoading={isLoading}
          data={data}
          onFullTextLinkClick={onFullTextLinkClick}
          onIssueCitedCounterClick={onIssueCitedCounterClick}
          onExperimentalProcedureOpen={onExperimentalProcedureOpen}
          onAbstractOpen={onAbstractOpen}
          onAuthorClick={onAuthorClick}
          saveStepSelectionsHandler={saveStepSelectionsHandler}
          stepId={step}
          viewSelected={selected}
        />
      );
    }
    case RouteType.PREDICTED: {
      const { isLoading, examples, firstPriorityData, lastPriorityData, step, selected } = stepData;
      return (
        <StepDataExamples
          isLoading={isLoading}
          examples={examples}
          placement={placement}
          firstPriorityData={firstPriorityData}
          lastPriorityData={lastPriorityData}
          saveStepSelectionsHandler={saveStepSelectionsHandler}
          stepId={step}
          viewSelected={selected}
          loadLastExamples={loadLastExamples}
        />
      );
    }
    default: {
      return null;
    }
  }
};
/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable  react/default-props-match-prop-types */
function Conditions({
  routeType,
  placement,
  setPlacement,
  setIsShown,
  activeStep,
  setActiveStep,
  steps,
  fetchStepData,
  onUnmount,
  resized,
  onActiveStepChange,
  onFullTextLinkClick,
  onIssueCitedCounterClick,
  onExperimentalProcedureOpen,
  onAbstractOpen,
  onAuthorClick,
  saveStepSelectionsHandler,
  loadLastExamples,
}) {
  const activeStepData = useMemo(() => find(steps, { step: activeStep }), [steps, activeStep]);
  const activeStepType = (activeStepData && activeStepData.type) || routeType;

  useEffect(() => {
    // If conditions opened, but no active step selected - select 1st as active
    if (!activeStep && !isEmpty(steps)) {
      setActiveStep(steps[0].step);
    }
  }, [steps]);

  useEffect(() => {
    // If step is opened but no data and was not yet requested - fetch data for step
    if (activeStepData && !activeStepData.data && !activeStepData.requested) {
      fetchStepData(activeStepType, activeStepData);
    }
  }, [activeStep]);

  useEffect(
    () => () => {
      onUnmount();
    },
    []
  );

  return (
    <>
      {steps && (
        <ConditionsTopPanel
          placement={placement}
          setPlacement={setPlacement}
          setIsShown={setIsShown}
          steps={steps}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          resized={resized}
          onActiveStepChange={onActiveStepChange}
        />
      )}
      {renderStepData({
        placement,
        onFullTextLinkClick,
        onIssueCitedCounterClick,
        onExperimentalProcedureOpen,
        onAbstractOpen,
        onAuthorClick,
        saveStepSelectionsHandler,
        loadLastExamples,
        ...activeStepData,
        type: activeStepType,
      })}
    </>
  );
}

Conditions.defaultProps = {
  onUnmount: () => null,
  onExperimentalProcedureOpen: () => null,
  onFullTextLinkClick: () => null,
  onIssueCitedCounterClick: () => null,
  onAbstractOpen: () => null,
  onAuthorClick: () => null,
  saveStepSelectionsHandler: () => null,
};
Conditions.propTypes = {
  saveStepSelectionsHandler: PropTypes.func,
  loadLastExamples: PropTypes.func,
};
export default Conditions;
